export type MeasureWidth = (text: string) => number;

export function wrapLines(
  text: string,
  maxWidth: number,
  measure: MeasureWidth,
): string[] {
  if (!text) return [''];
  const paragraphs = text.split(/\r\n|\r|\n/);
  const output: string[] = [];
  for (const paragraph of paragraphs) {
    if (paragraph === '') {
      output.push('');
      continue;
    }
    const words = paragraph.split(/[^\S\r\n]+/).filter(Boolean);
    if (words.length === 0) {
      output.push('');
      continue;
    }
    let current = '';
    for (const word of words) {
      const test = current ? `${current} ${word}` : word;
      if (measure(test) <= maxWidth || !current) {
        current = test;
      } else {
        output.push(current);
        current = word;
      }
    }
    if (current) output.push(current);
  }
  return output.length ? output : [''];
}
